import React, { Component } from 'react';

import { Input, Container, Message } from 'semantic-ui-react';

class Mailing extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            success: false,
            error: false,
            message: "",
            address: ""
        }

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleClick(event, data) {
        this.setState({ loading: true });

        fetch("https://us-central1-writing-assistant-39e3f.cloudfunctions.net/mailing/", {
            method: "POST",
            body: JSON.stringify({ email: this.state.address }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
            .then(response => {
                let status = response.status;
                this.setState({ loading: false });

                if (status === 200) {
                    this.setState({ 
                        success: response.ok,
                        error: !response.ok,
                        message: "Apparently you had already signed up earlier! Thanks for your interest!"});
                } else if (status === 201) {
                    this.setState({
                        success: true,
                        error: false,
                        message: "Thanks for signing up! We'll send you more details about dicted.io and will keep you updated!"});
                } else if (status === 400) {
                    this.setState({
                        success: false,
                        error: true,
                        message: "The email you give is doesn't seem to be proper, can you double-check it and try again?"});
                } else {
                    this.setState({
                        success: false,
                        error: true,
                        message: "Something went wrong when trying to sign you up, it's probably nothing wrong with the email you entered. Can you please try again later?"});
                }
            })
            .catch(err => {
                this.setState({
                    success: false,
                    error: true,
                    message: "Sorry, can't send the sign up request, can you please try again later?"
                });
            });
    }

    handleChange(event, data) {
        this.setState({ address: data.value });
    }

    render() {
        return (                                
            <Container>                         
            <Input
            action={{ color: 'blue', 
                    labelPosition: 'right', 
                    icon: 'mail', 
                    loading: this.state.loading,
                    onClick: this.handleClick,
                    content: 'Tell me more' }} 
            placeholder='type your email in here'
            disabled={ this.state.loading || this.state.success }
            error={ this.state.error }
            onChange={this.handleChange}
            fluid />
            <p><small>you can see what we do with your email address&nbsp; 
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer">here</a>
            </small>
            </p>
            <Message
            header={ this.state.message }
            hidden={ this.state.success !== true && this.state.error !== true }
            success={ this.state.success }
            negative={ this.state.error } />
            </Container>);
    }

}

export { Mailing };



// WEBPACK FOOTER //
// ./src/Mailing.js